import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, COMPANIES } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	Name = "name",
	Companies = "companies",
	TaxiServices = "taxiServices",
	CarParks = "carParks",
}

export const translationTablePath = "settings.carParks.general.columns.";

const settingsCarParksGeneral = makeTable({
	allIds: [
		ColumnId.Name,
		ColumnId.Companies,
		ColumnId.TaxiServices,
		ColumnId.CarParks,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.Name,
		ColumnId.Companies,
		ColumnId.TaxiServices,
		ColumnId.CarParks,
	],
	initialSortMethod: {
		column: ColumnId.Name,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.Name]: 500,
		[ColumnId.Companies]: COMPANIES,
		[ColumnId.TaxiServices]: 430,
		[ColumnId.CarParks]: DATE,
	},
	initialResizable: {
		[ColumnId.Name]: true,
		[ColumnId.Companies]: true,
		[ColumnId.TaxiServices]: true,
		[ColumnId.CarParks]: true,
	},
	initialSortable: {
		[ColumnId.Name]: true,
		[ColumnId.Companies]: true,
		[ColumnId.TaxiServices]: true,
		[ColumnId.CarParks]: true,
	},
});

export default settingsCarParksGeneral;
